import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import ProviderInfo from './ProviderInfo';
import extractText from 'flarum/common/utils/extractText';
import Icon from 'flarum/common/components/Icon';
export default class LinkStatus extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      loading: false
    });
  }
  view() {
    return m("div", {
      className: `LinkedAccountsList-item LinkedAccountsList-item--${this.attrs.provider.name()}`
    }, this.iconView(), this.statusView(), this.actionView());
  }
  iconView() {
    return m("div", {
      className: "LinkedAccountsList-item-icon"
    }, m(Icon, {
      name: this.attrs.provider.icon(),
      className: `Provider-Icon Provider-Icon--${this.attrs.provider.name()}`
    }));
  }
  statusView() {
    const provider = this.attrs.provider;
    return m(ProviderInfo, {
      provider: provider
    });
  }
  actionView() {
    const provider = this.attrs.provider;
    const user = this.attrs.user;
    if (provider.linked()) {
      return m("div", {
        className: "LinkedAccountsList-item-actions"
      }, m(Button, {
        className: `Button FoFLogInButton LogInButton--${provider.name()} LogInButton${provider.linked() ? '--linked' : '--unlinked'}`,
        icon: provider.icon(),
        onclick: () => this.deleteProvider(provider),
        loading: this.state.loading
      }, app.translator.trans('fof-oauth.forum.unlink')));
    } else if (!provider.orphaned() && (user.id() === app.session.user?.id() || !app.forum.attribute('fofOauthModerate'))) {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      const linkUrl = `${app.forum.attribute('baseUrl')}/auth/${provider.name()}?linkTo=${user.id()}&returnTo=${returnTo}`;
      return m("div", {
        className: "LinkedAccountsList-item-actions"
      }, m(Button, {
        className: `Button FoFLogInButton LogInButton--${provider.name()}`,
        icon: provider.icon(),
        onclick: e => {
          e.preventDefault();
          window.location.href = linkUrl;
        },
        loading: this.state.loading
      }, app.translator.trans(`fof-oauth.forum.log_in.with_${provider.name()}_button`, {
        provider: app.translator.trans(`fof-oauth.forum.providers.${provider.name()}`)
      })));
    }
    return null;
  }
  async deleteProvider(provider) {
    if (confirm(extractText(app.translator.trans('fof-oauth.forum.user.settings.linked-account.unlink-confirm', {
      provider: app.translator.trans(`fof-oauth.forum.providers.${provider.name()}`)
    })))) {
      this.state.loading = true;
      await provider.delete();
      await this.attrs.refresh?.();
      this.state.loading = false;
    }
  }
}
flarum.reg.add('fof-oauth', 'forum/components/LinkStatus', LinkStatus);